/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SSOSessionResult { 
    /**
     * Token
     */
    token?: string;
    /**
     * Id Hash. UUI (Unique User Identifier)
     */
    userIdHash?: string;
}

